export default __webpack_public_path__ + "static/sundare-spel-pa-svenska-casino-744f44611acf02e4d74a1f104209df9b.jpg";